import React from "react";
import { useRecoilValue } from "recoil";
import PropTypes from "prop-types";
import { getClinicEndGameStats } from "state/clinicGameState";
import GameCompletionDetailsOverlay from "components/games/widgets/GameCompletionDetailsOverlay";
import { getLinkLocation } from "utils/ClinicAdminLinks";
import { addOrdinalSuffixToNumber } from "utils/numeric";

export default function GameOver({
	clinicId,
	dashboard = false,
	gameId,
}) {
	const gameEndStats = useRecoilValue(getClinicEndGameStats({ clinicId, gameId }));

    if (gameEndStats) {
        if (dashboard) {
            const { rank } = gameEndStats;
            const rankText = addOrdinalSuffixToNumber(rank);
            return (
                <GameCompletionDetailsOverlay
                    wide
                    onClick={!!clinicId ? () => history.push(getLinkLocation("historic-games", clinicId)) : null}
                >
                    <span>You won <em>{rankText}</em> place!</span>
                    <br />
                    <span>Click in to view your prize.</span>
                </GameCompletionDetailsOverlay>
            );
        }

        const { doses, prizeDisplayName, prizeAmount } = gameEndStats;
        const winner = prizeDisplayName && prizeDisplayName !== "N/A" || prizeAmount > 0;
        const wonText = (!!prizeDisplayName && prizeDisplayName !== "N/A") ? prizeDisplayName : `$${prizeAmount || 0}`;
        return (
            <GameCompletionDetailsOverlay>
                You sold <em>{doses}</em> doses{winner && ` and won ${wonText}`}!
            </GameCompletionDetailsOverlay>
        );
    }
}

GameOver.propTypes = {
    clinicId: PropTypes.number.isRequired,
	dashboard: PropTypes.bool,
    gameId: PropTypes.number.isRequired,
};
